import React from 'react';
import ReactDOM from 'react-dom';
import './global.scss';
import {App} from './Pages';

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);
